import { render, staticRenderFns } from "./FolderOfferItemHeader.vue?vue&type=template&id=e39c8014&scoped=true"
import script from "./FolderOfferItemHeader.vue?vue&type=script&lang=js"
export * from "./FolderOfferItemHeader.vue?vue&type=script&lang=js"
import style0 from "./FolderOfferItemHeader.vue?vue&type=style&index=0&id=e39c8014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39c8014",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
